/*
 * File: ForgotPassword.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd October 2024 4:33:58 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 11:28:47 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import EntryLayoutScreen from '../../components/shared/EntryLayout/EntryLayout';
import CustomTextField from '../../components/shared/CustomTextField/CustomTextField';
import styles from './ForgotPassword.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { useInput } from '../../customHook/useInput';
import validator from 'validator';
import { AuthService } from '../../service/auth.service';
import CustomButton from '../../components/shared/CustomButton/CustomButton';
import zeplinColor from '../../theme/Color';
import RoutePaths from '../../routes/RoutePaths';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Constants, Error } from '../../utilities/constants';

const ForgotPassword = () => {
  const navigate = useNavigate();

  sessionStorage.removeItem('reset-user');
  sessionStorage.removeItem('next');
  const {
    handleChange,
    handleBlur,
    value: email,
    error,
    setError,
    invalid,
    didChange,
  } = useInput('', validator.isEmail);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const forgotPassword = async () => {
    try {
      handleOpen();
      const res = await AuthService.forgotPassword({ userName: email });
      // console.log(res);
      if (res?.$metadata?.httpStatusCode === 200) {
        navigate(RoutePaths.ResetPassword);
        sessionStorage.setItem('reset-user', email);
        sessionStorage.setItem('next', 'otp');
      }
    } catch (err: any) {
      // setError(err?.response?.data?.name.split(/(?=[A-Z])/).splice(0,2).join(' '))
      const message: Error = err?.response?.data?.name || err?.response?.data || '';
      // if(err?.response?.data?.name===Error.ExpiredCode){
      console.log(err);
      setError(Constants.ErrorText[message] || err?.response?.data || 'Something went wrong');
      // }
    } finally {
      // Hide loading indicator
      handleClose();
    }
  };

  const children = (
    <div className={styles['forgot-password-input']}>
      <CustomTextField
        onChange={handleChange}
        style={{ width: '50%' }}
        onBlur={handleBlur}
        name='email'
        text={email}
        error={error ? error : invalid && didChange ? 'Please enter valid email' : ''}
        label='Email address'
        type='email'
      />
      <CustomButton
        onClick={forgotPassword}
        variant='contained'
        disabled={!invalid ? false : true}
        color={email ? 'primary' : 'customDisable'}
        style={{ width: '50%', borderRadius: '14px', height: 56 }}
        textStyle={{ color: email ? zeplinColor.Neutral1 : zeplinColor.Neutral8 }}
        text={'Get 6-digit code'}
      />
      <Link to={RoutePaths.Root}>
        <CustomButton
          disabled={false}
          variant='text'
          text={'Back to Log in'}
          icon={<ArrowBackIcon />}
          textStyle={{ color: zeplinColor.Brand1 }}
          onClick={() => {}}
        />
      </Link>
    </div>
  );

  return (
    <EntryLayoutScreen
      header={'Forgot Password?'}
      subheader={"Please enter your email and we'll send you a 6-digit code."}
      input={children}
      alternative={''}
      footerText=''
      footerButtonText=''
      icon={
        <div
          style={{
            backgroundColor: zeplinColor.Neutral3,
            borderRadius: '70px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            width: '80px',
            height: '80px',
            padding: '20px',
          }}
        >
          <img src={'/assets/forgot-password.svg'} width={40} height={40} />
        </div>
      }
      clickAction={() => {}}
      open={open}
      handleCloseModal={handleClose}
    />
  );
};

export default ForgotPassword;
